import _Constantes from './Constantes';
import _Config from './Config';
import _InputDatoPerfil from './InputDatoPerfil';
import _InputArchivo from './InputIArchivo';

export const Constantes = _Constantes;
export const Config = _Config;
export const InputDatoPerfil = _InputDatoPerfil;
export const InputArchivo = _InputArchivo;